import { useCallback } from 'react';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';

export default function useFireTradeIncentiveEvents() {
  const trackEvent = useTrackEvent();

  return useCallback(
    (consumer: string) => {
      trackEvent('Rendered Trade Incentive Content', {
        consumer
      });
    },
    [trackEvent]
  );
}
